import React, { useState, useEffect } from 'react';
import { MessageSquare } from 'lucide-react';

const StickyTextButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button after scrolling down 300px
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const handleTextClick = () => {
    window.location.href = 'sms:+16027304994';
  };

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-8 right-8 z-50">
          <button
            onClick={handleTextClick}
            className="bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700 text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-cyan-500/50 transition-all duration-300 hover:scale-110 flex items-center gap-2 font-bold text-lg animate-bounce"
          >
            <MessageSquare className="w-6 h-6" />
            <span>Text Us / Order</span>
          </button>
          
          {/* Pulsing ring effect */}
          <div className="absolute inset-0 rounded-full bg-cyan-500 animate-ping opacity-20 pointer-events-none"></div>
        </div>
      )}
    </>
  );
};

export default StickyTextButton;
